import React from 'react';
import { Switch, Redirect, Route, useHistory } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import '../../../public/static/stylesheets/fonts.css';
import '../../stylesheets/public.postcss';

// Components
import { Footer, Search, Explore, Support, BlogPost, Blog, BlogSearchResults, BlogCategory, Truck, Location, Home, OfficeParks, Residential, Breweries, Privacy, Terms, Error404Page, Error500Page, Catering, WeddingCatering, CorporateCatering, CommunityEvents, CateringRegister, Login, ChooseAccount, Register, Vendors, DessertCatering, BurgerCatering, AsianCatering, TacoCatering, BbqCatering, PizzaCatering, BreakfastCatering, BirthdayPartyCatering, CateringPrices, FoodTruckRental, HireAFoodTruck, EventCatering, PrivatePartyCatering, SpecialOccasionsCatering, FundraiserCatering, OfficeLunchCatering, DeletionStatus, ForgotPassword, AllCategory, TacoCategory, SandwichCategory, DessertCategory, BbqCategory, BurgerCategory, AsianCategory, PizzaCategory, BreakfastCategory, GyroCategory, HealthyCategory } from './Layout.imports-loadable';
import Header from './public/nav/Header';
import Meta from './shared/Meta';
import ErrorModal from './shared/ErrorModal';
import FloatingCta from './shared/FloatingCta';

function Layout() {
  const history = useHistory();

  return (
    <div className='public-layout'>
      <a className='skip-link' href='#main-content'>Skip to main content</a>
      <Meta />
      <Header />

      <main id='main-content' className='MainContent'>
        <Sentry.ErrorBoundary fallback={<Error500Page />}>
          <Switch>
            <Route path='/search/:id' component={Search} />
            <Route path='/explore' component={Explore} />
            <Route path='/search' component={Search} />
            <Route path='/food-trucks/:id' component={Truck} />
            <Redirect path='/food-trucks' to='/search' />
            <Route path='/blog/category/:id' component={BlogCategory} />
            <Route path='/blog/:id' component={BlogPost} />
            <Route path='/blog-search' component={BlogSearchResults} />
            <Route path='/blog' component={Blog} />
            <Route path='/schedule/:id' component={Location} />
            <Route path='/services/office-parks' component={OfficeParks} />
            <Route path='/services/residential' component={Residential} />
            <Route path='/services/breweries' component={Breweries} />
            <Redirect exact path='/services' to='/services/office-parks' />
            <Route path='/privacy-policy' component={Privacy} />
            <Route path='/terms-and-conditions' component={Terms} />
            <Route path='/deletion-status' component={DeletionStatus} />
            <Route path='/catering/register' component={CateringRegister} />
            <Route path='/category/all' component={AllCategory} />
            <Route path='/taco-trucks' component={TacoCategory} />
            <Route path='/sandwich-food-trucks' component={SandwichCategory} />
            <Route path='/dessert-food-trucks' component={DessertCategory} />
            <Route path='/bbq-food-trucks' component={BbqCategory} />
            <Route path='/burger-food-trucks' component={BurgerCategory} />
            <Route path='/asian-food-trucks' component={AsianCategory} />
            <Route path='/pizza-food-trucks' component={PizzaCategory} />
            <Route path='/breakfast-food-trucks' component={BreakfastCategory} />
            <Route path='/gyro-food-trucks' component={GyroCategory} />
            <Route path='/healthy-food-trucks' component={HealthyCategory} />
            <Route path='/food-truck-catering/wedding-catering' component={WeddingCatering} />
            <Route path='/food-truck-catering/corporate-catering' component={CorporateCatering} />
            <Route path='/food-truck-catering/dessert-catering' component={DessertCatering} />
            <Route path='/food-truck-catering/burger-catering' component={BurgerCatering} />
            <Route path='/food-truck-catering/asian-catering' component={AsianCatering} />
            <Route path='/food-truck-catering/taco-catering' component={TacoCatering} />
            <Route path='/food-truck-catering/bbq-catering' component={BbqCatering} />
            <Route path='/food-truck-catering/pizza-catering' component={PizzaCatering} />
            <Route path='/food-truck-catering/breakfast-catering' component={BreakfastCatering} />
            <Route path='/food-truck-catering/birthday-parties' component={BirthdayPartyCatering} />
            <Route path='/food-truck-catering/community-events' component={CommunityEvents} />
            <Route path='/food-truck-catering/prices' component={CateringPrices} />
            <Route path='/food-truck-catering/events' component={EventCatering} />
            <Route path='/food-truck-catering/private-parties' component={PrivatePartyCatering} />
            <Route path='/food-truck-catering/special-occasions' component={SpecialOccasionsCatering} />
            <Route path='/food-truck-catering/fundraiser' component={FundraiserCatering} />
            <Route path='/food-truck-catering/office-lunch' component={OfficeLunchCatering} />
            <Route path='/food-truck-rental' component={FoodTruckRental} />
            <Route path='/hire-a-food-truck' component={HireAFoodTruck} />
            <Route path='/catering' component={Catering} />
            <Route path='/forgot-password' component={ForgotPassword} />
            <Route path='/login' history={history} component={Login} />
            <Route path='/choose-account' component={ChooseAccount} />
            <Route path='/vendor/register' component={Register} />
            <Route path='/vendors' component={Vendors} />
            <Route path='/about' component={Vendors} />
            <Route path='/support' component={Support} />
            <Route exact path='/error' component={Error500Page} />
            <Route exact path='/not-found' component={Error404Page} />
            <Route exact path='/' component={Home} />
            <Route component={Error404Page} />
          </Switch>
        </Sentry.ErrorBoundary>

        <ErrorModal />
      </main>

      <Footer />
      <FloatingCta />
    </div>
  );
}

export default Layout;
